import {
  Autocomplete,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useState } from 'react';
import {
  useGetAssigneesMutation,
  useGetCountriesQuery,
  useGetSitesQuery,
  useLazyGetStudiesQuery
} from 'src/services/Utils';
import { useAppDispatch } from 'src/store';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const AddandUpdateProtocolQA: React.FunctionComponent<any> = ({
  setCreateData,
  createData,
  updateData,
  edit,
  setUpdateData,
  topic,
  status,
  initialState,
  submit,
  currentProtocolQALevel,
  protocolQALogPermissions,
  setDisableSubmit,
  setWarningMessage
}) => {
  const [irbReportDateIssue, setIrbReportDateIssue] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { preferedFormatForDatePicker, userPreferedDateFormat } = usePreferedDateFormat();
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const [studyRefetch, { data: studyData, isError: studyIsError }] = useLazyGetStudiesQuery();
  useEffect(() => {
    studyRefetch();
  }, []);
  const {
    data: countryData,
    isError: countryIsError,
    refetch: countryget
  } = useGetCountriesQuery(edit ? updateData.study_id : createData.study_id);
  const {
    data: siteData,
    isError: siteIsError,
    refetch: siteget
  } = useGetSitesQuery({
    currentStudy: edit ? updateData.study_id : createData.study_id,
    currentCountry: edit ? updateData.country : createData.country
  });
  const [studylist, setStudylist] = useState<any>([]);
  const [countrylist, setCountrylist] = useState<any>([]);
  const [sitelist, setSitelist] = useState<any>([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
      }
    }
  };

  useEffect(() => {
    if (studyData && !studyIsError) {
      const tempArr = studyData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setStudylist(tempArr);
    } else {
      setStudylist([]);
    }
  }, [studyData, studyIsError]);
  useEffect(() => {
    if (countryData && !countryIsError) {
      const tempArr = countryData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setCountrylist(tempArr);
    } else {
      setCountrylist([]);
    }
  }, [countryData, countryIsError]);
  useEffect(() => {
    if (siteData && !siteIsError) {
      const tempArr = siteData.map((ele: any) => {
        return { label: ele.name, ...ele };
      });
      setSitelist(tempArr);
    } else {
      setSitelist([]);
    }
  }, [siteData, siteIsError]);

  const handleChange = (event: any) => {
    setDisableSubmit(false);
    setWarningMessage(true);
    if (edit) {
      setUpdateData({ ...updateData, [event.target.name]: event.target.value });
    } else {
      setCreateData({ ...createData, [event.target.name]: event.target.value });
    }
  };

  const [qaAssigne, setQaAssigne] = useState<any>([]);

  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();

  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = [];
      assignees.map((item: any) =>
        assignList.push({
          key: `${item.first_name} ${item.last_name} (${item.email})`,
          displayName: `${item.first_name} ${item.last_name} (${item.email})`
        })
      );
      setQaAssigne(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  useEffect(() => {
    getAssignees({
      client_name: 'ctms-ui',
      data: [`UPDATE_RESPONSE_${currentProtocolQALevel}_PROTOCOLQALOG`]
    });
  }, []);

  const [initialStudy, setStudyInitial] = useState(false);
  const [initialCountry, setCountryInitial] = useState(false);
  useEffect(() => {
    if (initialStudy) {
      if (updateData.study_id === null) {
        updateData.country = null;
        updateData.site_id = null;
        setCountrylist([]);
        setSitelist([]);
      } else if (updateData.study_id) {
        updateData.country = null;
        updateData.site_id = null;
        countryget();
      }
      if (createData.study_id === null) {
        createData.country = null;
        createData.site_id = null;
        setCountrylist([]);
        setSitelist([]);
      } else if (createData.study_id) {
        initialState.study_id = null;
        initialState.country = null;
        initialState.site_id = null;
        createData.country = null;
        createData.site_id = null;
        countryget();
      }
    }
    setStudyInitial(true);
  }, [createData.study_id, updateData.study_id]);
  useEffect(() => {
    if (initialCountry) {
      if (createData.country === null) {
        createData.site_id = null;
      } else if (createData.country !== initialState.country) {
        createData.site_id = null;
        siteget();
      }
      if (updateData.country === null) {
        updateData.site_id = null;
        setSitelist([]);
      } else if (updateData.country !== initialState.country) {
        updateData.site_id = null;
        siteget();
      }
    }
    setCountryInitial(true);
  }, [createData.country, updateData.country]);

  const qaUsersList: any = [];
  qaAssigne?.map((data: any) => {
    qaUsersList.push(data.displayName);
  });

  return (
    <Grid container item rowSpacing={3} columnSpacing={3}>
      <Grid item xs={12}>
        <FormControl variant="standard" fullWidth>
          <TextField
            disabled
            name="qn_no"
            label="Question Number"
            variant="standard"
            value={edit ? updateData.qa_no : createData.qa_no}
            inputProps={{
              maxLength: 100
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <FormControl
          variant="standard"
          fullWidth
          error={edit ? (submit ? updateData.study_id === null : false) : submit ? createData.study_id === null : false}
        >
          <Autocomplete
            disabled={
              edit
                ? // ? protocolQALogPermissions.update || protocolQALogPermissions.updateOther
                  true
                : // : true
                  false || currentProtocolQALevel == 'SITE'
            }
            disablePortal
            id="combo-box-demo"
            options={studylist}
            onChange={(_: any, newValue: any | null) => {
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, study_id: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, study_id: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.study_id : createData.study_id}
            className={currentProtocolQALevel === 'SITE' ? 'required' : ''}
            renderInput={params => (
              <TextField
                error={submit ? createData.study_id === null : false}
                {...params}
                label="Study"
                className="alignFields"
              />
            )}
          />
          {(edit ? (submit ? updateData.study_id === null : false) : submit ? createData.study_id === null : false) && (
            <FormHelperText>Required</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            disabled={
              edit
                ? // ? protocolQALogPermissions.update || protocolQALogPermissions.updateOther
                  true
                : // : true
                  false || currentProtocolQALevel == 'SITE'
            }
            disablePortal
            id="combo-box-demo"
            options={countrylist}
            onChange={(_: any, newValue: any | null) => {
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, country: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, country: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.country : createData.country}
            renderInput={params => <TextField {...params} label="Country" className="alignFields" />}
            className={currentProtocolQALevel === 'SITE' ? 'required' : ''}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            disabled={
              edit
                ? // ? protocolQALogPermissions.update || protocolQALogPermissions.updateOther
                  true
                : // : true
                  false || currentProtocolQALevel == 'SITE'
            }
            disablePortal
            id="combo-box-demo"
            options={sitelist}
            onChange={(_: any, newValue: any | null) => {
              setDisableSubmit(false);
              edit
                ? setUpdateData({ ...updateData, site_id: newValue !== null ? newValue.label : null })
                : setCreateData({ ...createData, site_id: newValue !== null ? newValue.label : null });
            }}
            value={edit ? updateData.site_id : createData.site_id}
            renderInput={params => <TextField {...params} label="Site" className="alignFields" />}
            className={currentProtocolQALevel === 'SITE' ? 'required' : ''}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <TextField
            name="issued_by"
            label="Issued By"
            disabled={
              edit ? (protocolQALogPermissions.update || protocolQALogPermissions.updateOther ? false : true) : false
            }
            variant="standard"
            value={edit ? updateData.issued_by : createData.issued_by}
            onChange={handleChange}
            inputProps={{
              maxLength: 50
            }}
          />
        </FormControl>
      </Grid>

      <Grid item xs={6}>
        <FormControl variant="standard" fullWidth>
          <InputLabel id="demo-simple-select-standard-label">Topic</InputLabel>
          <Select
            MenuProps={menuProps}
            labelId="demo-simple-select-standard-label"
            name="topic"
            disabled={
              edit ? (protocolQALogPermissions.update || protocolQALogPermissions.updateOther ? false : true) : false
            }
            value={edit ? updateData.topic : createData.topic}
            onChange={handleChange}
            label="Topic"
          >
            {topic?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {item.code_list_value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            name="summary"
            label="Summary"
            disabled={
              edit ? (protocolQALogPermissions.update || protocolQALogPermissions.updateOther ? false : true) : false
            }
            variant="standard"
            value={edit ? updateData.summary : createData.summary}
            onChange={handleChange}
            inputProps={{
              maxLength: 200
            }}
            helperText="200 character limit"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            name="description"
            label="Description"
            disabled={
              edit ? (protocolQALogPermissions.update || protocolQALogPermissions.updateOther ? false : true) : false
            }
            variant="standard"
            value={edit ? updateData.description : createData.description}
            onChange={handleChange}
            inputProps={{
              maxLength: 2000
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} mb={2} mt={1}>
        <FormControl variant="standard" fullWidth>
          <InputLabel id="demo-simple-select-standard-label" />
          <Autocomplete
            className="customNamePicker"
            disabled={
              edit ? (protocolQALogPermissions.update || protocolQALogPermissions.updateOther ? false : true) : false
            }
            disablePortal
            id="demo-simple-select-standard-label"
            options={qaUsersList}
            autoComplete
            // for filtering the autocomplete list with atleast 3 characters
            filterOptions={(options: Array<any>, state: any) => {
              let filteredOption: any = [];
              filteredOption = options.filter((item: any) => {
                if (state?.inputValue.length >= 3) {
                  if (
                    item.toLowerCase() === state?.inputValue.toLowerCase() ||
                    item.toLowerCase().includes(state?.inputValue.toLowerCase())
                  ) {
                    return item;
                  }
                }
              });
              return filteredOption;
            }}
            renderTags={(value: readonly any[], getTagProps) =>
              value.map((option: any, index: number) => (
                <div key={index} className="autoCompleteChip">
                  <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                </div>
              ))
            }
            onChange={(event, newValue) => {
              setDisableSubmit(false);
              if (edit) {
                setUpdateData({ ...updateData, protocol_qa_assigned_to: newValue });
              } else {
                setCreateData({ ...createData, protocol_qa_assigned_to: [newValue] });
              }
            }}
            value={edit ? updateData.protocol_qa_assigned_to : createData.protocol_qa_assigned_to}
            renderInput={params => (
              <TextField
                error={false}
                {...params}
                label="Question Assigned To"
                placeholder="Please enter initial 3 characters of the name for user assignment"
              />
            )}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            disabled={
              edit
                ? !protocolQALogPermissions.update &&
                  !protocolQALogPermissions.updateOther &&
                  !protocolQALogPermissions.updateResponse
                : false
            }
            name="response"
            label="Response"
            variant="standard"
            value={edit ? updateData.response : createData.response}
            inputProps={{
              maxLength: 2000
            }}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} className="withDatePicker w100">
        <LocalizationProvider dateAdapter={AdapterDayjs} variant="standard" className="custom-datePicker" fullWidth>
          <DesktopDatePicker
            disabled
            disableOpenPicker
            inputFormat={dateFormat}
            label="Response Date"
            value={preferedFormatForDatePicker(edit ? updateData.response_dt : createData.response_dt)}
            onChange={(newValue: any) => {
              setDisableSubmit(false);
              if (newValue === null) {
                setDisableSubmit(false);
                setCreateData({ ...createData, response_dt: null });
                setUpdateData({ ...updateData, response_dt: null });
              }
              if (newValue !== null) {
                setCreateData({ ...createData, response_dt: new Date(newValue).toLocaleDateString('en-CA') });
                setUpdateData({ ...updateData, response_dt: new Date(newValue).toLocaleDateString('en-CA') });
              }
              //IRB report date inline error message
              if (new Date(newValue).toLocaleDateString('en-CA') === 'Invalid Date') {
                setIrbReportDateIssue(true);
              } else {
                setIrbReportDateIssue(false);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                error={
                  (edit
                    ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                      ? submit
                        ? updateData.date_irb === undefined || updateData.date_irb === null
                        : false
                      : false
                    : createData.reported_irb === 'Yes' || createData.reported_irb === true
                    ? submit
                      ? createData.date_irb === undefined || createData.date_irb === null
                      : false
                    : false) || irbReportDateIssue
                }
                helperText={
                  (
                    edit
                      ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                        ? submit
                          ? updateData.date_irb === undefined || updateData.date_irb === null
                          : false
                        : false
                      : createData.reported_irb === 'Yes' || createData.reported_irb === true
                      ? submit
                        ? createData.date_irb === undefined || createData.date_irb === null
                        : false
                      : false
                  )
                    ? 'Required'
                    : irbReportDateIssue
                    ? 'Invalid Date'
                    : ''
                }
                required={
                  edit
                    ? updateData.reported_irb === 'Yes' || updateData.reported_irb === true
                    : createData.reported_irb === 'Yes' || createData.reported_irb === true
                }
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <FormControl variant="standard" fullWidth>
          <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            name="status"
            disabled={edit ? !protocolQALogPermissions.update && !protocolQALogPermissions.updateOther : false}
            value={edit ? updateData.status : createData.status}
            onChange={handleChange}
            label="Status"
          >
            {status?.map((item: any) => {
              return (
                <MenuItem key={item.id} value={item.code_list_value}>
                  {item.code_list_value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default React.memo(AddandUpdateProtocolQA);
